import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function LitigationAndConsultancyServices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="dava-ve-danışmanlık-hizmetleri" ref={ref} className="dark bg-linear-to-b from-[#0a1120] to-[#1c1e22] text-foreground relative flex min-h-[60vh] flex-col items-center justify-center overflow-hidden px-6 py-24 text-center md:px-12 lg:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_center,var(--muted)_0%,transparent_70%)] opacity-20" />

      <div className={cn("relative z-10 mx-auto max-w-4xl space-y-8 transition-all duration-1000 ease-out", isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0")}>
        <h1 className="font-serif text-4xl font-medium tracking-tight text-[#cbd5e1] sm:text-5xl md:text-6xl lg:text-7xl">
          Dava ve Danışmanlık Hizmetleri
        </h1>

        <div className="mx-auto h-px w-24 bg-[#c5a059]" />

        <p className="font-['Montserrat'] text-lg leading-relaxed text-muted-foreground md:text-xl md:leading-8">
          Isparta merkezli ofisimiz, 2017'den beri ceza, aile, gayrimenkul ve
          şirketler hukuku alanlarında uzmanlaşmış kadrosuyla kesintisiz hukuki
          destek sağlamaktadır. Müvekkillerimizin haklarını, mesleki etik
          kurallar çerçevesinde ve çözüm odaklı bir yaklaşımla en üst düzeyde
          temsil ediyoruz.
        </p>

        <div className="pt-4">
          <Link to="https://celikhukuk.net/iletisim/">
            <Button size="lg" className="min-w-[200px] rounded-full text-base font-medium transition-transform hover:scale-105">
              İletişime Geçin
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}